import React from 'react';

const Card = ({ title, children }) => (
  <div className="bg-white rounded-lg shadow-md p-6 mb-6 transition-transform hover:translate-y-[-5px]">
    <h2 className="text-xl font-semibold mb-4 pb-2 border-b-2 border-blue-300">{title}</h2>
    {children}
  </div>
);

export default Card;